import type { AnalyticsConnector } from '@inditex/coanalytjs';
import createAnalytics from './core/create-analytics';
import { createTrackConfig } from './core/track-config';
import { createEvent, getRegisteredEventTypes } from './events';
import { getIdentityProvider } from './core/identity-provider';
import type { IIdentityProvider } from './core/identity-provider';
import { getEnv } from 'src/utils/EnvironmentTools';

class Coanalyt {
	private static _instance: Coanalyt | null = null;
	private analyticsConnector: AnalyticsConnector;
	private identity: IIdentityProvider;

	static getInstance(): Coanalyt {
		if (!Coanalyt._instance) {
			Coanalyt._instance = new Coanalyt();
		}
		return Coanalyt._instance;
	}

	private constructor() {
		this.analyticsConnector = createAnalytics();
		this.identity = getIdentityProvider();
	}

	track(eventType: string, data?: unknown): void {
		const event = createEvent({ eventType, data });
		if (!event) return;

		const trackConfig = createTrackConfig(this.identity);
		this.analyticsConnector.track(event as Parameters<AnalyticsConnector['track']>[0], { config: trackConfig });
	}

	init(): void {
		// Register event listeners if an event bus is available
		const eventTypes = getRegisteredEventTypes();
		if(getEnv()?.env !== 'pro') {
			console.log('[Coanalyt] Initialized with event types:', eventTypes);
		}
	}

	/** Expose for testing or direct access */
	getConnector(): AnalyticsConnector {
		return this.analyticsConnector;
	}

	/** Reset singleton (useful for testing) */
	static reset(): void {
		Coanalyt._instance = null;
	}
}

export default Coanalyt;
